export const initialAdvanceApplicationState = () => ({
  sessionId: null,
  partyId: null,
  currencyId: null,
  advanceId: null,
  advances: [],
  invoices: [],
  history: [],
  currencyRates: {},
  lines: {},
  busy: false,
  loading: false
});

export const reduceAdvanceApplication = (state, action, resetType, updateType) => {
  if (action.type === resetType) {
    if (action.previousSessionId !== undefined && action.previousSessionId !== state.sessionId) return state;
    return {
      ...initialAdvanceApplicationState(),
      sessionId: action.sessionId,
      currencyRates: action.preserveRates ? state.currencyRates : {}
    };
  }
  if (action.type === updateType && action.sessionId !== null && action.sessionId === state.sessionId) {
    return { ...state, ...action.payload };
  }
  return state;
};
